import React, { useState } from "react"
import styled from "styled-components"
import { useTranslation } from "react-i18next"
import Icon from "@mdi/react"
import { mdiEarth } from "@mdi/js"
import _ from "lodash"
import { Link } from "gatsby"

const PaginationBtn = styled.button`
  padding: 6px 12px;
  margin-left: -1px;
  color: #337ab7;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #ddd;
  display: inline-block;
  font-size: 16px;
  line-height: 16px;

  &.active {
    background-color: #2cabe3;
    border-color: #2cabe3;
    color: white;
  }

  &[disabled] {
    pointer-events: none;
    cursor: not-allowed;
    background-color: #fff;
    color: #777;
  }

  &.prevBtn {
  }

  &.nextBtn {
  }
`

const SupportPageList = styled.div`
  min-height: 500px;
  width: 66.6%;
  padding-right: 24px;
  /* float: left; */
  @media screen and (max-width: 414px) {
    width: 100%;
    padding-right: 0px;
  }
`

const SupportPageListItem = styled(Link)`
  width: 100%;
  min-height: 100px;
  border-bottom: 1px solid var(--ud-greyeb);
  padding: 0px 15px;
  color: black;
  display: block;
  .supportPage__listItemQuestion {
    padding: 13px 0px 9px 0px;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
    text-decoration: none;
    width: 100%;
    display: flex;
    align-items: center;
    color: black;
    svg {
      margin-right: 15px;
    }
  }
  > span {
    font-weight: normal;
    font-size: 14px;
    color: #3C3C3C;
    line-height: 20px;
  }
  &:hover {
    .supportPage__listItemQuestion {
      text-decoration: underline;
    }
  }

  .supportPage__listItemPreview {
    font-weight: normal;
    font-size: 14px;
    color: var(--ud-grey3c);
    margin: 0px 0px 15px 0px;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }

  &.skeleton {
    width: 100%;
    .supportPage__listItemQuestion span {
      background-color: #f1f1f1;
      width: 75%;
      height: 25px;
      position: relative;
      overflow: hidden;
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0,
          rgba(255, 255, 255, 0.2) 20%,
          rgba(255, 255, 255, 0.5) 60%,
          rgba(255, 255, 255, 0)
        );
        animation: shimmer 2s infinite;
        content: "";
      }
    }
    > span {
      background-color: #f1f1f1;
      width: 100%;
      height: 38px;
      display: block;
      position: relative;
      overflow: hidden;
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0,
          rgba(255, 255, 255, 0.2) 20%,
          rgba(255, 255, 255, 0.5) 60%,
          rgba(255, 255, 255, 0)
        );
        animation: shimmer 2s infinite;
        content: "";
      }
    }

    @keyframes shimmer {
      100% {
        transform: translateX(100%);
      }
    }
  }
`

const pageLimit = 5

const Questions = ({
  t,
  questionList,
  offset = 0,
  location,
  loading,
  lang,
}) => {
  if (loading) {
    return Array.from({ length: 5 }).map(() => {
      return (
        <SupportPageListItem as="div" className="skeleton">
          <div className="supportPage__listItemQuestion skeleton">
            <span className="skeleton" />
          </div>
          <span className="skeleton" />
        </SupportPageListItem>
      )
    })
  }
  if (questionList && !_.isEmpty(questionList)) {
    const questions = questionList.map(faq => (
      <SupportPageListItem key={faq.id} to={`/${lang}/faq/${faq.id}/`}>
        <div className="supportPage__listItemQuestion">
          <Icon path={mdiEarth} size={0.5} />
          <span dangerouslySetInnerHTML={{ __html: `${faq.title}` }} />
        </div>
        <span dangerouslySetInnerHTML={{ __html: `${faq.preview}` }} />
      </SupportPageListItem>
    ))
    return questions
  }
  return <span>{t("no_data_available")}</span>
}

function ClientSideQuestionList(props) {
  const { t, i18n } = useTranslation()
  const [offset, setOffset] = useState(0)
  const { questionList, location, loading } = props
  const totalPages =
    Math.ceil(questionList.length / pageLimit) === 0
      ? 1
      : Math.ceil(questionList.length / pageLimit)

  return (
    <SupportPageList>
      <div style={{ minHeight: "500px" }}>
        <Questions
          t={t}
          questionList={questionList.slice(
            offset * pageLimit,
            offset * pageLimit + pageLimit
          )}
          location={location}
          loading={loading}
          offset={offset}
          lang={i18n.language}
        />
      </div>
      <div style={{ display: "inline-block", margin: "20px 0" }}>
        <PaginationBtn
          rel="prev"
          disabled={offset === 0}
          onClick={() => {
            if (offset > 0) {
              setOffset(offset - 1)
            }
          }}
        >
          {t("page_previous")}
        </PaginationBtn>
        {Array.from({ length: totalPages }).map((o, index) => {
          return (
            <PaginationBtn
              className={offset === index ? "active" : ""}
              key={`pagination-number${index + 1}`}
              onClick={() => {
                setOffset(index)
              }}
            >
              {index + 1}
            </PaginationBtn>
          )
        })}
        <PaginationBtn
          rel="next"
          disabled={offset === totalPages - 1}
          onClick={() => {
            if (offset < totalPages) {
              setOffset(offset + 1)
            }
          }}
        >
          {t("page_next")}
        </PaginationBtn>
      </div>
    </SupportPageList>
  )
}

export default ClientSideQuestionList
